import { AxiosRequestHeaders } from 'axios';
import { isPresent } from 'utils/isPresent';

import getCSRFHeader from 'components/Common/api/getCSRFToken';
import inMemoryStore from 'components/Common/InMemoryStore';

const getRequestHeaders = (): AxiosRequestHeaders => {
  const impersonateOrgId = inMemoryStore.read('IMPERSONATE_ORG_ID');
  const token = inMemoryStore.read('customer_retrieval_token') || inMemoryStore.read('resource_token');

  const impersonatedHeader: AxiosRequestHeaders = isPresent(impersonateOrgId)
    ? ({
        ADMINOVERRIDE: impersonateOrgId,
      } as AxiosRequestHeaders)
    : {};

  const authTokenHeader: AxiosRequestHeaders = isPresent(token)
    ? {
        AUTHORIZATION: `Token ${token}`,
      }
    : {};

  return {
    ...getCSRFHeader(),
    ...impersonatedHeader,
    ...authTokenHeader,
  };
};

export default getRequestHeaders;
